import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';

class Image extends React.PureComponent {
    componentDidMount() {
        const { lazyLoadingOptions  } = this.props;
        if (lazyLoadingOptions) {
            // Set the image quality back to default from a low quality image state
            this.setState({
                q: '',
                auto: ''
            });
        }
    }
    render() {
        const { url , onClick , className , children  } = this.props;
        const { q , auto  } = this.state;
        const urlOptionQuality = q && `&q=${q}`;
        const urlOptionAutomatic = auto && `&auto=${auto}`;
        const lazyLoadingUrl = url + urlOptionQuality + urlOptionAutomatic;
        return onClick ? /*#__PURE__*/ React.createElement("button", {
            className: classnames('image', className),
            onClick: onClick
        }, this.renderImage(lazyLoadingUrl, this.props)) : /*#__PURE__*/ React.createElement("div", {
            className: classnames('image', className)
        }, this.renderImage(lazyLoadingUrl, this.props), children);
    }
    constructor(...args){
        super(...args);
        this.state = {
            q: this.props.lazyLoadingOptions && this.props.lazyLoadingOptions.q || '',
            auto: this.props.lazyLoadingOptions && this.props.lazyLoadingOptions.auto || ''
        };
        this.renderImage = (lazyLoadingUrl, _param)=> {
            var { lazyLoadingOptions , cover , alt  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
                "lazyLoadingOptions",
                "cover",
                "alt"
            ]);
            return React.createElement("span", {
                className: "image__background-image",
                role: "img",
                "aria-label": Boolean(rest['aria-hidden']) ? undefined : alt,
                "aria-hidden": rest['aria-hidden'],
                style: {
                    backgroundImage: `url('${lazyLoadingUrl}')`,
                    backgroundSize: `${cover ? 'cover' : 'contain'}`
                }
            });
        };
    }
}

export { Image as default };
//# sourceMappingURL=Image.js.map
